import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Campaign, CampaignData } from "../data/campaign";
import { MessageHandlerService } from "../../services/message-handler.service";
import { EventEmitter } from "@angular/core";

@Injectable()
export class CampaignProjectService extends CampaignData {
  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiCampaign: string;
  header: any;
  constructor(
    private http: HttpClient,
    private messageHandler: MessageHandlerService
  ) {
    super();
    this.api = environment.apiUrl;
  }

  async createCampaign(data) {
    try {
      let response = await this.http
        .post(this.api + "campaign", data)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getCampaigns(pagination, filter, order) {
    console.log({ pagination, filter, order });1
    try {
      let response = await this.http
        .post(this.api + "campaigns", { pagination, filter, order })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getCampaign(id: string) {
    try {
      let Campaign = <Campaign>(
        await this.http.get(this.api + "campaign/" + id).toPromise()
      );
      return Campaign;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async editCampaign(data, id?: string) {
    try {
      let response = <Campaign>(
        await this.http
          .put(this.api + "campaign/" + (id || ""), data)
          .toPromise()
      );
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async deleteCampaign(id?: string) {
    try {
      let response = <Campaign>(
        await this.http.delete(this.api + "campaign/" + id).toPromise()
      );
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async exportCampaignId(dateStart: any, dateEnd: any, id: any) {
    try {
      let response = await this.http
        .post(this.api + "campaign/export/" + id, { dateStart, dateEnd })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async getPresets(id: string) {
    try {
      let Campaign = <Campaign>(
        await this.http.get(this.api + "campaign/preset/" + id).toPromise()
      );
      return Campaign;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async createPreset(data) {
    try {
      let response = await this.http
        .post(this.api + "preset", data)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

}
